import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail, MapPin, ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  const quick = [
    [t('nav.about'), '/about'],
    [t('nav.services'), '/services'],
    [t('nav.cases'), '/cases'],
    [t('nav.blog'), '/blog'],
    [t('nav.contact'), '/contact'],
  ];
  const useful = ['Privacy Policy', 'Terms & Conditions', 'Support', 'FAQ', 'Client Portal'];

  return (
    <footer className="bg-[#14110f] text-white/80 pt-20 pb-10 relative overflow-hidden">
      <div className="absolute -top-24 -right-20 w-[420px] h-[420px] rounded-full bg-[#f5b300]/8 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-20 w-[480px] h-[480px] rounded-full bg-[#6b3f24]/30 blur-3xl pointer-events-none" />

      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 relative">
        <div className="lg:col-span-4">
          <div>
            <p className="text-[22px] font-extrabold text-white">WYSE<span className="text-[#f5b300]">Tribe</span></p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1">{t('brand.sub')}</p>
          </div>
          <p className="mt-5 text-[15px] text-white/65 leading-relaxed max-w-sm">{t('footer.tagline')}</p>
          <div className="flex items-center gap-3 mt-6">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#f5b300] hover:border-[#f5b300] hover:text-[#14110f] transition-all">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-white text-[16px] font-semibold mb-5">{t('footer.quick')}</h4>
          <ul className="space-y-3 text-[14px]">
            {quick.map(([l, p]) => (
              <li key={p}>
                <Link to={p} className="hover:text-[#f5b300] transition-colors flex items-center gap-1.5 group">
                  <ArrowRight className="w-3 h-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#f5b300]" />
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-white text-[16px] font-semibold mb-5">{t('footer.useful')}</h4>
          <ul className="space-y-3 text-[14px]">
            {useful.map((l) => (
              <li key={l}>
                <a href="#" className="hover:text-[#f5b300] transition-colors flex items-center gap-1.5 group">
                  <ArrowRight className="w-3 h-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all text-[#f5b300]" />
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-white text-[16px] font-semibold mb-5">{t('footer.contact')}</h4>
          <ul className="space-y-4 text-[14px]">
            <li className="flex gap-3"><Mail className="w-4 h-4 text-[#f5b300] mt-0.5 shrink-0" /> info@wysetribe.ca</li>
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#f5b300] mt-0.5 shrink-0" /> 246 Stewart Green SW, Unit 6319, Calgary, AB, T3H 3C8</li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-6 mt-14 pt-7 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-white/55">
        <p>&copy; {new Date().getFullYear()} {t('footer.copy')}</p>
        <p>{t('footer.cpa')}</p>
      </div>
    </footer>
  );
}
